module.exports = __webpack_public_path__ + "img/kv_bg.28558a11.png";